import { createPlugin } from '../../../Fct/createPlugin';
import { FctString, FctStringList, FctTextarea } from '../../../Fct/generics';
export var ReactComponent = createPlugin({
    protocol: 'FUNCTIONS',
    type: 'GETTER',
    method: 'reactComponent',
    name: 'reactComponent',
    flowType: 'REACT_COMPONENT',
    getParams: function () { return ({
        input: {
            name: new FctString({ description: 'Meaningful name for component', isPreview: true }),
            path: new FctString({ description: 'path of React component', isPreview: true }),
            component: new FctTextarea({
                required: true,
                description: 'React component code',
            }),
            npmPackages: new FctStringList({ required: false, hidden: true }),
            methodParams: {},
        },
        output: {},
    }); },
});
